module.exports = __webpack_public_path__ + "static/logo-8405971bc95616fa876beccf31d7c323.png";